export const TestIds = {
  label: 'ToggleSwitch_label',
  checkedIcon: 'ToggleSwitch_checked_icon',
  uncheckedIcon: 'ToggleSwitch_unchecked_icon',
  outerLabel: 'ToggleSwitch_outer_label',
  switchWrapper: 'ToggleSwitch_switch_wrapper',
} as const;
